class SystemsDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#systems-datatable', organizationID);
        this.initActions(organizationID);
        this.initFilter();
    }
    init(el, organizationID){
        let thisClass = this;
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[1, 'asc']],
            ajax: {
                url: '?do=getSystems',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: 'row-selected-light-primary-bg'
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=systems-datatable_length]').select2({minimumResultsForSearch: -1});
                $(el + ' tbody tr').attr('data-cy', 'system');
            },
            columns: [
                {
                    data: 'uuid',
                    title: '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-1">' +
                        '       <input class="form-check-input cursor-pointer" type="checkbox" data-kt-check="true" data-kt-check-target="'+el+' .form-check-input" data-kt-check-all="true" value="1"/>' +
                        '   </div>',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-1">'+
                            '    <input class="form-check-input cursor-pointer" type="checkbox" value="'+row['uuid']+'"'+(!row['edit'] ? ' disabled' : '')+'/>'+
                            '</div>';
                    }
                },
                {
                    data: 'system',
                    title: 'System',
                    sortable: true,
                    render: function (data, type, row) {
                        let iconUrl = '/media/goodaccess/icons/system/'+row['iconID']+'.svg';
                        let serviceHtml = '';
                        if(row['isAdvanced'] && row['services']){
                            serviceHtml = new ServiceTooltip().getHtml(row['services']);
                        }

                        return '<div class="d-flex align-items-center" data-cy="system-card">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white'+(!row['isValid'] || row['isIsolated'] ? ' filter-grayscale' : '')+'">' +
                            '               <img src="'+iconUrl+'" alt="icon">' +
                            '           </div>' +
                            (serviceHtml !== '' ? '<span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="'+serviceHtml+'">'+row['services'].length+'</span>' : '')+
                            (!row['isValid'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-9 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Invalid</div>">&#33;</span>' : '') +
                            (row['isIsolated'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Isolated</div>">&#10005;</span>' : '') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div data-cy="system-id" id="'+row['uuid']+'"><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 '+ (row['edit'] ? 'edit-system' : '') +'" data-system-name="'+row['name']+'">'+row['name']+'</span>'+
                            (row['isIcmpProtocolEnabled'] ? '<span class="ms-2 fst-italic fs-9 badge badge-sm badge-warning py-1" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>ICMP protocol enabled</div>">ICMP</span>' : '')+
                            (row['customUri'] ? '' : '<i class="fa-solid fa-eye-slash ga-text-primary-700 ms-2" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Not visible as a System Shortcut in GoodAccess Client Application.</div>"></i>') +'</div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+(row['customUri'] ?? row['host'])+'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'description',
                    title: 'Description',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<span class="fw-semibold d-block fs-7 ga-text-primary-800" '+(row['description'] !== row['shortDescription'] ? 'data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="'+row['description']+'"' : '')+'>'+(row['shortDescription'] ? row['shortDescription'] : "")+'</span>';
                    }
                },
                {
                    data: 'accessCards',
                    title: 'Access cards',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '';
                        for (let i = 0; i < row['accessCards'].length; i++) {
                            if(row['edit']){
                                html += '<span class="badge badge-danger me-1 mb-1 cursor-pointer text-hover-white bg-hover-danger edit-access-card" id="'+row['accessCards'][i]['uuid']+'">'+row['accessCards'][i]['name']+'</span>';
                            } else {
                                html += '<span class="badge badge-danger me-1 mb-1">'+row['accessCards'][i]['name']+'</span>';
                            }
                        }
                        return html;
                    }
                },
                {
                    data: 'groupsArr',
                    title: 'Groups',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        for(let i = 0; i < row['groupsArr'].length; i++){
                            if (i < 3) {
                                html += new GroupInfoGenerator().generateSystemIconView(row['groupsArr'][i]['name'], row['groupsArr'][i]['edit'], row['groupsArr'][i]['uuid'], row['groupsArr'][i]['numberOfSystems']);
                            } else {
                                html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['groupsArr'].length - 3)+' more Groups</div>">' +
                                    '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-system' : '') +'">+'+(row['groupsArr'].length - 3)+'</div>'+
                                    '     </div>';
                                break;
                            }
                        }
                        return html+'</div>';
                    }
                },
                {
                    data: null,
                    title: 'Actions',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3" id="'+row['uuid']+'">';
                        if (row['edit']) {
                            html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-system" data-cy="edit-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                    '     <span class="svg-icon svg-icon-3">' +
                                    '          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '             <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>' +
                                    '             <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>' +
                                    '         </svg>' +
                                    '     </span>' +
                                    '</div>';
                            html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 delete-system" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete" data-cy="delete-btn">'+
                                '     <span class="svg-icon svg-icon-3">' +
                                '           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '               <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '          </svg>' +
                                '      </span>' +
                                '</div>';
                            html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" data-cy="more-actions-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="More Actions" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">' +
                                '     <span class="svg-icon svg-icon-3">' +
                                '         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '             <rect x="10" y="10" width="4" height="4" rx="2" fill="currentColor"/>' +
                                '             <rect x="17" y="10" width="4" height="4" rx="2" fill="currentColor"/>' +
                                '             <rect x="3" y="10" width="4" height="4" rx="2" fill="currentColor"/>' +
                                '         </svg>' +
                                '     </span>' +
                                '</div>' +
                                '<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto" data-kt-menu="true">' +
                                '     <div class="menu-item text-primary" id="'+row['uuid']+'">' +
                                '          <span class="menu-link px-3 text-primary fs-7 duplicate-system" data-cy="duplicate-btn">' +
                                '                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">' +
                                '                      <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="currentColor"/>' +
                                '                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="currentColor"/>' +
                                '                </svg>' +
                                '                Duplicate System' +
                                '          </span>' +
                                '     </div>' +
                                (row['isIsolated'] ?
                                '     <div class="menu-item text-primary" id="'+row['uuid']+'">' +
                                '          <span class="menu-link px-3 text-primary fs-7 de-isolate-system" data-cy="de-isolate-btn">' +
                                '                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2"> ' +
                                '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/> ' +
                                '                   <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>' +
                                '                </svg>' +
                                '                De-isolate System' +
                                '          </span>' +
                                '     </div>' :
                                '     <div class="menu-item text-primary" id="'+row['uuid']+'">' +
                                '          <span class="menu-link px-3 text-primary fs-7 isolate-system" data-cy="isolate-btn">' +
                                '                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">' +
                                '                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>' +
                                '                    <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>' +
                                '                    <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>' +
                                '                </svg>' +
                                '                Isolate System' +
                                '          </span>' +
                                '     </div>')+
                                '</div>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#systems-datatable_wrapper').hide();
                $('#systems-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        }).on('select', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'}).count();
            if(selectedRows === displayedRows){
                $('#systems-datatable_wrapper [data-kt-check-all]').prop('checked', true);
            }
        }).on('deselect', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'}).count();
            if(selectedRows !== displayedRows){
                $('#systems-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            }
        }).on('draw', function () {
            thisClass.removeSelectedRows(organizationID);
            $('#systems-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            if(datatable.page.info().recordsTotal !== 0){
                $('#systems-datatable_wrapper').show();
                $('#systems_tab [data-kt-docs-table-filter=search]').parent().show();
            }
            const container = document.querySelector('#systems_tab');
            const baseToolbar = container.querySelector('[data-kt-docs-table-toolbar="base"]');
            const selectedToolbar = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
            if(selectedToolbar){
                selectedToolbar.classList.add('d-none');
            }
            if(baseToolbar){
                baseToolbar.classList.remove('d-none');
            }

            KTMenu.createInstances();
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '#systems_tab [data-kt-docs-table-filter=search]');
        return datatable;
    }
    removeSelectedRows(organizationID){
        const thisClass = this;
        // Toggle selected action toolbar
        // Select all checkboxes
        const container = document.querySelector('#systems_tab');
        const checkboxes = container.querySelectorAll('[type="checkbox"]');

        // Select elements
        const deleteSelected = container.querySelector('[data-kt-docs-table-select="delete_selected"]');

        // Toggle delete selected toolbar
        checkboxes.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', async function () {
                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            });
        });

        // Deleted selected rows
        if(deleteSelected) {
            deleteSelected.addEventListener('click', function () {
                let systemIDs = thisClass.getSelectedIDs();
                let html = `
                    <span class="text-center text-primary">Are you sure you want to delete selected Systems?</span>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                            I agree
                        </label>
                    </div>`;
                Swal.fire({
                    html: html,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0 cy-system-delete-confirm-btn",
                        cancelButton: 'btn btn-light-primary mt-0 cy-system-delete-cancel-btn',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        let swalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                        if(swalCheckbox && !swalCheckbox.checked){
                            Swal.showValidationMessage(`You need to agree`);
                            return;
                        }

                        return fetch('/systems?do=removeSystem&organizationID='+organizationID+'&systemIDs='+systemIDs)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                console.log(error);
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value.status === 'warning'){
                            toastr.error(result.value.message);
                        } else {
                            toastr.success(result.value.message);
                            new PageDatatableReload(false);
                            let numberOfSystemsElement = $(".number-of-systems");
                            if(numberOfSystemsElement){
                                numberOfSystemsElement.text(parseInt(numberOfSystemsElement.text()) - systemIDs.length);
                            }
                        }
                    }
                });
            });
        }
    }
    toggleToolbars() {
        // Define variables
        const container = document.querySelector('#systems_tab');
        const toolbarSelected = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
        if(toolbarSelected){
            const selectedCount = container.querySelector('[data-kt-docs-table-select="selected_count"]');
            // Select refreshed checkbox DOM elements
            const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

            // Detect checkboxes state & count
            let checkedState = false;
            let count = 0;

            // Count checked boxes
            allCheckboxes.forEach(c => {
                if (c.checked) {
                    checkedState = true;
                    count++;
                }
            });

            // Toggle toolbars
            if (checkedState) {
                selectedCount.innerHTML = count;
                toolbarSelected.classList.remove('d-none');
            } else {
                toolbarSelected.classList.add('d-none');
            }
        }
    }
    getSelectedIDs(){
        // Define variables
        const container = document.querySelector('#systems-datatable_wrapper');
        // Select refreshed checkbox DOM elements
        const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

        let ids = [];

        // Count checked boxes
        allCheckboxes.forEach(c => {
            if (c.checked) {
                ids.push(c.value);
            }
        });
        return ids;
    }
    initActions(organizationID) {
        const thisClass = this;

        /** Select All rows */
        $(document).on('click','#systems-datatable [data-kt-check-all]',function(e){
            if ($(this).is(':checked')) {
                thisClass.datatable.rows().select();
            } else {
                thisClass.datatable.rows().deselect();
            }
        });

        $(document).on('click', '#systems-datatable .delete-system', function(e) {
            let systemID = $(this).parent()[0].id;
            let systemName = $(this).closest('tr').find('span[data-system-name]').attr('data-system-name');
            Swal.fire({
                html: `<span class="text-center text-primary">System `+(systemName !== undefined ? `<b>`+systemName+`</b> ` : ``)+`is going to be completely deleted!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/systems?do=removeSystem&organizationID='+organizationID+'&systemID='+systemID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 'warning'){
                        toastr.error(result.value.message);
                    } else {
                        toastr.success(result.value.message);

                        let editSystemModal = document.getElementById('edit_system_modal');
                        if(editSystemModal){
                            bootstrap.Modal.getOrCreateInstance(editSystemModal).hide();
                        }
                        new PageDatatableReload(false);

                        let numberOfSystemsElement = $(".number-of-systems");
                        if(numberOfSystemsElement){
                            numberOfSystemsElement.text(parseInt(numberOfSystemsElement.text()) - 1);
                        }
                    }
                }
            });
        });

        $(document).on('click', '#systems-datatable .isolate-system', function(e) {
            let systemID = $(this).parent()[0].id;
            let systemName = $(this).closest('tr').find('span[data-system-name]').attr('data-system-name');
            Swal.fire({
                html: `<div class="text-center text-primary">System `+(systemName !== undefined ? `<b>`+systemName+`</b> ` : ``)+`is going to be isolated!</div>
                    <div class="text-center text-primary mt-5 fw-bold">No one will have access to this system!</div>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="isolateSystemSwalCheckbox" type="checkbox" value="" id="isolateSystemSwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="isolateSystemSwalCheckbox">
                             I agree
                        </label>
                    </div>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    let isolateSystemSwalCheckbox = document.querySelector('input[name="isolateSystemSwalCheckbox"]');
                    if(isolateSystemSwalCheckbox && !isolateSystemSwalCheckbox.checked){
                        Swal.showValidationMessage(`You need to agree`);
                        return;
                    }

                    return fetch('/systems?do=changeIsolatedStatus&organizationID='+organizationID+'&systemID='+systemID+'&isIsolated=1')
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 'warning'){
                        toastr.error(result.value.message);
                    } else {
                        toastr.success(result.value.message);
                        new PageDatatableReload(false);
                    }
                }
            });
        });

        $(document).on('click', '#systems-datatable .de-isolate-system', function(e) {
            let systemID = $(this).parent()[0].id;
            let systemName = $(this).closest('tr').find('span[data-system-name]').attr('data-system-name');
            Swal.fire({
                html: `<div class="text-center text-primary">System `+(systemName !== undefined ? `<b>`+systemName+`</b> ` : ``)+`is going to be de-isolated!</div>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="deIsolateSystemSwalCheckbox" type="checkbox" value="" id="deIsolateSystemSwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="deIsolateSystemSwalCheckbox">
                             I agree
                        </label>
                    </div>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    let deIsolateSystemSwalCheckbox = document.querySelector('input[name="deIsolateSystemSwalCheckbox"]');
                    if(deIsolateSystemSwalCheckbox && !deIsolateSystemSwalCheckbox.checked){
                        Swal.showValidationMessage(`You need to agree`);
                        return;
                    }

                    return fetch('/systems?do=changeIsolatedStatus&organizationID='+organizationID+'&systemID='+systemID+'&isIsolated=0')
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value.status === 'warning'){
                        toastr.error(result.value.message);
                    } else {
                        toastr.success(result.value.message);
                        new PageDatatableReload(false);
                    }
                }
            });
        });
    }
    initFilter(){
        const thisClass = this;
        this.initFilterSelect2();

        // Apply
        const applyFilterButton = document.querySelector('[data-table-filter-action="systems-datatable-apply"]');
        if(applyFilterButton) {
            applyFilterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }

        // Reset
        const resetFilterButton = document.querySelector('[data-table-filter-action="systems-datatable-reset"]');
        if(resetFilterButton){
            resetFilterButton.addEventListener('click', function () {
                // Reset inputs
                $('[data-table-filter="systems-datatable-status"]').val([]).trigger('change');
                $('[data-table-filter="systems-datatable-access-card"]').val([]).trigger('change');
                $('[data-table-filter="systems-datatable-group"]').val([]).trigger('change');

                $('input[data-table-filter="without-groups"]').prop("checked", false);
                $('input[data-table-filter="without-access-cards"]').prop("checked", false);

                thisClass.applyFilter(true);
            });
        }
    }
    initFilterSelect2(){
        const optionImgFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML =
                '<div class="d-flex align-items-center p-0" style="max-width:150px;">'+
                    item.element.getAttribute('data-icon')+
                '   <span class="fs-6 fw-semibold text-primary ms-2">' + item.text + '</span>'+
                '</div>';
            return $(span);
        }

        const optionTextFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML =
                '<div class="d-flex align-items-center" style="max-width:150px;">'+
                '   <span class="fs-6 fw-semibold ms-2">' + item.text + '</span>'+
                '</div>';
            return $(span);
        }

        const initSelect2 = (element, optionFormat) => {
            if(element){
                $(element).select2({
                    placeholder: "Select an option",
                    templateSelection: optionFormat,
                    templateResult: optionFormat,
                    minimumResultsForSearch: -1,
                    dropdownParent: $('#systemsFilterMenu'),
                    allowClear: true,
                }).on('select2:select', function (e) {
                    KTMenu.updateDropdowns()
                });

                // Prevent menu from closing when deselecting an item from select2
                const menuEl = document.querySelector("#systemsFilterMenu");
                if (menuEl) {
                    const menu = KTMenu.getInstance(menuEl);
                    if (menu) {
                        $(element).on('select2:unselect', function (e) {
                            element.setAttribute("data-multiple-unselect", "1");
                        });
                        $(element).on('select2:clear', function (e) {
                            $(element).val([]).trigger("change");
                        });
                        menu.on("kt.menu.dropdown.hide", function(item) {
                            if (element.getAttribute("data-multiple-unselect") === "1") {
                                element.removeAttribute("data-multiple-unselect");
                                return false;
                            }
                        });
                    }
                }
            }
        };

        // Init Select2
        const accessCardSelectEl = document.querySelector('[data-table-filter="systems-datatable-access-card"]');
        const groupSelectEl = document.querySelector('[data-table-filter="systems-datatable-group"]');

        initSelect2(accessCardSelectEl, optionTextFormat);
        initSelect2(groupSelectEl, optionImgFormat);
    }
    applyFilter(reset = false){
        const thisClass = this;
        let numberOfActiveFilters = 0;
        let numberOfActiveFiltersEl = document.getElementById('systemsDatatableNumberOfActiveFilters');

        if(reset){
            this.datatable.columns().search('');
        } else {
            let status = $('[data-table-filter="systems-datatable-status"]').select2('data');
            let statusArr = [];
            for(const i in status){
                if(status[i].id !== ''){
                    statusArr.push(status[i].id);
                }
            }

            let accessCards = $('[data-table-filter="systems-datatable-access-card"]').select2('data');
            let withoutAccessCards = document.querySelector('input[data-table-filter="without-access-cards"]');
            let accessCardArr = [];
            for(const i in accessCards){
                if(accessCards[i].id !== ''){
                    accessCardArr.push(accessCards[i].id);
                }
            }
            if(withoutAccessCards && withoutAccessCards.checked){
                accessCardArr.push('without-access-cards');
            }

            let groups = $('[data-table-filter="systems-datatable-group"]').select2('data');
            let withoutGroups = document.querySelector('input[data-table-filter="without-groups"]');
            let groupArr = [];
            for(const i in groups){
                if(groups[i].id !== ''){
                    groupArr.push(groups[i].id);
                }
            }
            if(withoutGroups && withoutGroups.checked){
                groupArr.push('without-groups');
            }

            thisClass.datatable.column(1).search(JSON.stringify(statusArr));
            numberOfActiveFilters += statusArr.length;
            thisClass.datatable.column(3).search(JSON.stringify(accessCardArr));
            numberOfActiveFilters += accessCardArr.length;
            thisClass.datatable.column(4).search(JSON.stringify(groupArr));
            numberOfActiveFilters += groupArr.length;
        }
        numberOfActiveFiltersEl.innerText = numberOfActiveFilters;
        thisClass.datatable.draw();
    }
}
window.SystemsDatatable = SystemsDatatable;